<!-- Dialog -->
<div class="dialog">
    <div mat-dialog-content>
        <p>{{message}}</p>
    </div>
    <div mat-dialog-actions style="display: block">
        <button class="close" mat-button (click)="close()" aria-label="Cancel">Cancel</button>
        <button class="exit" mat-button (click)="exit()" cdkFocusInitial aria-label="Delete component">{{buttonText}}</button>
    </div>
</div>